import { GiTShirt, GiSunglasses, GiSofa } from "react-icons/gi";
import { HiSquares2X2 } from "react-icons/hi2";

const CATEGORY_ICON_MAP = {
  apparel: GiTShirt,
  accessories: GiSunglasses,
  "home & decor": GiSofa,
  "home and decor": GiSofa,
  others: HiSquares2X2,
};

const normalizeCategoryName = (name) =>
  name?.trim().toLowerCase().replace(/\s+/g, " ") || "";

export const getCategoryIcon = (name) => {
  return CATEGORY_ICON_MAP[normalizeCategoryName(name)] || HiSquares2X2;
};
